/**
 * ============================================================================
 * SpeakerForm — Service (API calls)
 * ============================================================================
 * Pure fetch wrappers. No JSX, no React state.
 * ============================================================================
 */

export async function submitSpeakerForm(payload: {
  ipstack: unknown;
  form: Record<string, unknown>;
  meta: Record<string, unknown>;
}) {
  const response = await fetch("/api/speaker", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });
  return response.json();
}
